module.exports = __webpack_public_path__ + "files/ae8b81a5db39cb279476837e1d07a96f.svg";